<div *ngIf="isValid">
    <qrcode [qrdata]="data.link" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</div>

<div *ngIf="!isValid">
    <span>Link inválido...</span>
</div>